import { Button, CardMedia, Input, TextField, MenuItem, Select, FormControl, InputLabel, Switch, FormControlLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { ChangeEvent, useState } from "react";

const AddVideoTutorial = () => {
    const navigate = useNavigate();

    // Video preview URL
    const [video, setVideo] = useState<string>("");

    // File name (optional use)
    const [fileName, setFileName] = useState<string>("");

    // Form fields
    const [title, setTitle] = useState<string>("");
    const [duration, setDuration] = useState<string>("");
    const [category, setCategory] = useState<string>("Vendor Onboarding");
    const [isVisible, setIsVisible] = useState<boolean>(true);

    return (
        <>
            {/* Page Title */}
            <div className="main_title">
                <h1>Add Video Tutorial</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/video-tutorials")}>
                        Video Tutorials
                    </button>{" "}
                    - Add
                </p>
            </div>

            {/* Form */}
            <form className="form cards">
                <div className="gap_p">



                    {/* Upload Video */}
                    <div className="control_group w_100">
                        <label htmlFor="video-upload">
                            Upload Video<span className="req">*</span>
                        </label>

                        {video ? (
                            <div className="upload_image">
                                <div className="upload_image_holder no_radius v2">
                                    <figure>
                                        <video
                                            src={video}
                                            controls
                                            style={{ width: "100%", borderRadius: "8px" }}
                                        />
                                    </figure>

                                    {/* Remove Video */}
                                    <CloseIcon
                                        onClick={() => {
                                            setVideo("");
                                            setFileName("");
                                        }}
                                    />
                                </div>
                            </div>
                        ) : (
                            <label className="upload_image" htmlFor="video-upload">
                                <Input
                                    sx={{ display: "none" }}
                                    id="video-upload"
                                    type="file"
                                    inputProps={{ accept: "video/mp4,video/webm,video/ogg" }}
                                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                        const files = event.target.files;
                                        if (files && files[0].type.includes("video")) {
                                            setFileName(files[0].name);
                                            setVideo(URL.createObjectURL(files[0]));
                                        }
                                    }}
                                />

                                <span className="upload_image_holder no_radius">
                                    <figure className="add_img">
                                        <img src="/static/images/placeholder.png" alt="video" />
                                        <span className="upload_img_icon">
                                            <img src="/static/images/edit2_icon.svg" alt="upload" />
                                        </span>
                                    </figure>
                                </span>
                            </label>
                        )}
                    </div>

                    {/* Video Title */}
                    <div className="control_group w_100">
                        <label htmlFor="video-title">
                            Video Title<span className="req">*</span>
                        </label>
                        <TextField
                            id="video-title"
                            placeholder="Enter video title"
                            fullWidth
                            hiddenLabel
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>

                    {/* Category & Visibility */}
                    <div className="control_group w_50">
                        <label htmlFor="video-category">
                            Category<span className="req">*</span>
                        </label>
                        <Select
                            id="video-category"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            fullWidth
                            size="small"
                        >
                            <MenuItem value="Vendor Onboarding">Vendor Onboarding</MenuItem>
                            <MenuItem value="Financials">Financials</MenuItem>
                            <MenuItem value="Marketing">Marketing</MenuItem>
                            <MenuItem value="AI Tools">AI Tools</MenuItem>
                        </Select>
                    </div>

                    <div className="control_group w_50" style={{ display: 'flex', alignItems: 'center', paddingTop: '30px' }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isVisible}
                                    onChange={(e) => setIsVisible(e.target.checked)}
                                />
                            }
                            label="Publish immediately"
                        />
                    </div>

                    {/* Duration */}
                    <div className="control_group w_50">
                        <label htmlFor="video-duration">
                            Duration<span className="req">*</span>
                        </label>
                        <TextField
                            id="video-duration"
                            placeholder="e.g. 05:30"
                            fullWidth
                            hiddenLabel
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}
                        />
                    </div>

                    {/* Footer Buttons */}
                    <div className="footer_btn_flex">
                        <Button className="btn btn_primary">
                            Save
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddVideoTutorial;
